import { language } from '@tencent/ppd-base-libs';

const lang = language.getLang(['zh-cn', 'zh-hk', 'en'], {
  key: 'lang',
  defaultLang: 'zh-hk',
  keyMap: {
    // 台湾也和繁体中文一样处理
    'zh-tw': () => 'zh-hk',
  },
});
let dataLang = '';
switch (lang) {
  case 'zh-cn':
    dataLang = window.lang_zh_cn;
    break;
  case 'zh-hk':
    dataLang = window.lang_zh_hk;
    break;
  case 'en':
    dataLang = window.lang_en;
    break;
  default:
    dataLang = window.lang_zh_hk;
}

export function getI18nData(key) {
  const data = dataLang[key];
  if (data) {
    return data;
  }
  return key;
}
